// extracted by mini-css-extract-plugin
module.exports = {"responsiveHeader":"ResponsiveHeader_responsiveHeader__z4VBq","responsiveHeader_portrait":"ResponsiveHeader_responsiveHeader_portrait__2OhHG"};